import { defineNuxtPlugin } from '#imports';
import { initRuntimeConfig } from '@core/utils/runtime-config';

export default defineNuxtPlugin(() => {
  initRuntimeConfig();
});
